<template>
  <div class="text-field">
    <input
      v-model="computedValue"
      type="text"
      :name="fieldName"
      :placeholder="placeholder"
      class="text-field-input"
    />
    <Icons v-if="icon" :name="icon" class="text-field-icon" />
  </div>
</template>

<script>
import Icons from '@sephora-asia/atoms-icons/Icons.vue'
export default {
  name: 'TextField',
  components: {
    Icons
  },
  props: {
    /**
     * Binding v-model value
     *
     * @type {String, Number}
     */
    value: {
      type: [String, Number]
    },
    /**
     * The field name for the text field.
     * Expects a string.
     *
     * @type {string}
     */
    fieldName: {
      type: String,
      default: ''
    },
    /**
     * Name of icon. Refer to list of supporting icons in Icons component.
     *
     * @type {string}
     */
    icon: {
      type: String,
      default: null
    },
    /**
     * The placeholder for the text field.
     * Optional field.
     *
     * @type {string}
     */
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      newValue: this.value,
      timeout: null
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.newValue
      },
      set(value) {
        this.newValue = value
        if (this.timeout) clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.$emit('input', value)
        }, 300)
      }
    }
  },
  watch: {
    // When v-model change, set internal value.
    value(value) {
      this.newValue = value
    }
  }
}
</script>

<style lang="scss">
.text-field {
  position: relative;
  display: flex;
  align-items: center;
}

.text-field-input {
  height: 40px;
  background: transparent;
  border: 1px solid $grey;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  width: 100%;
  z-index: 1;
  padding-left: 9px;
  padding-right: 40px;

  &:focus {
    border-color: $black;
    outline: none;

    + .text-field-icon {
      --icon-fill-color: #{$black};
    }
  }
}

.text-field-icon {
  --icon-size: 24px;
  --icon-fill-color: #{$grey};
  --cursor-type: pointer;
  position: absolute;
  right: 10px;
  z-index: 0;
}
</style>
